module.exports = __webpack_public_path__ + "img/digital_wallet.93800db0.png";